import { CSSProperties } from 'react';
import { appColors } from '@base/useTheme';
import { AtomicBlockUtils, EditorState, Modifier } from 'draft-js';

export const enum CustomTextSizeStyle {
    SIZE_10 = 'SIZE_10',
    SIZE_12 = 'SIZE_12',
    SIZE_14 = 'SIZE_14',
    SIZE_18 = 'SIZE_18',
}
const fontStyles = [
    CustomTextSizeStyle.SIZE_10,
    CustomTextSizeStyle.SIZE_12,
    CustomTextSizeStyle.SIZE_14,
    CustomTextSizeStyle.SIZE_18,
];

export const enum CustomTextColorStyle {
    COLOR_UI = 'COLOR_UI',
    COLOR_PRIMARY = 'COLOR_PRIMARY',
    COLOR_ERROR = 'COLOR_ERROR',
    COLOR_NEUTRAL = 'COLOR_NEUTRAL',
}
export const colorStyles = [
    CustomTextColorStyle.COLOR_UI,
    CustomTextColorStyle.COLOR_PRIMARY,
    CustomTextColorStyle.COLOR_ERROR,
    CustomTextColorStyle.COLOR_NEUTRAL,
];

export type CustomTextStyle = 'STRIKETHROUGH' | CustomTextSizeStyle | CustomTextColorStyle;

export const customTextStyles: Record<CustomTextStyle, CSSProperties> = {
    STRIKETHROUGH: { textDecoration: 'line-through' },
    [CustomTextSizeStyle.SIZE_10]: { fontSize: 10 },
    [CustomTextSizeStyle.SIZE_12]: { fontSize: 12 },
    [CustomTextSizeStyle.SIZE_14]: { fontSize: 14 },
    [CustomTextSizeStyle.SIZE_18]: { fontSize: 18 },
    [CustomTextColorStyle.COLOR_UI]: { color: appColors.ui.dark },
    [CustomTextColorStyle.COLOR_PRIMARY]: { color: appColors.primary.w500 },
    [CustomTextColorStyle.COLOR_ERROR]: { color: appColors.error.w500 },
    [CustomTextColorStyle.COLOR_NEUTRAL]: { color: appColors.neutral.w700 },
};

export function changeFontStyle(editorState: EditorState, sizeStyle: CustomTextSizeStyle) {
    let contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    for (const fontStyle of fontStyles) {
        contentState = Modifier.removeInlineStyle(contentState, selectionState, fontStyle);
    }
    contentState = Modifier.applyInlineStyle(contentState, selectionState, sizeStyle);
    const newState = EditorState.push(editorState, contentState, 'change-inline-style');
    return newState;
}

export function changeColorStyle(editorState: EditorState, colorStyle: CustomTextColorStyle) {
    let contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    for (const colorStyle of colorStyles) {
        contentState = Modifier.removeInlineStyle(contentState, selectionState, colorStyle);
    }
    contentState = Modifier.applyInlineStyle(contentState, selectionState, colorStyle);
    const newState = EditorState.push(editorState, contentState, 'change-inline-style');
    return newState;
}

export function insertImage(editorState: EditorState, base64: string) {
    const contentState = editorState.getCurrentContent();

    const contentStateWithEntity = contentState.createEntity('image', 'IMMUTABLE', { src: base64 });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newState = EditorState.set(editorState, { currentContent: contentStateWithEntity });

    return AtomicBlockUtils.insertAtomicBlock(newState, entityKey, ' ');
}
